<template>
    <b-container>
        <b-row align-v="center" class="mt-5">
            <b-col class="text-center">
                <b-img :src="course.course_thumbnail" fluid/>
            </b-col>
        </b-row>
        <b-row align-v="center" class="my-5">
            <b-col class="text-center">
                <h4>{{ course.course_title }}</h4>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="2">
                <strong>บทนำ :</strong>
            </b-col>
            <b-col md="10" v-html="course.course_intro">
            </b-col>
        </b-row>
        <b-row>
            <b-col md="2">
                <strong>คำชี้แจ้ง :</strong>
            </b-col>
            <b-col md="10" v-html="course.course_detail">
            </b-col>
        </b-row>

        <br>
        <questions :question_set_id="question_set_id"></questions>
    </b-container>
</template>

<script>
    import Questions from "../../components/Questions/Questions"

    export default {
        name: "CourseQuestion",
        components: {
            Questions
        },
        data(){
            return{
                course : this.$route.params.course,
                question_set_id: this.$route.params.question_set_id
            }
        },
        created(){
            if(typeof this.course === "undefined"){
                this.$router.push({ name: "courses"})
            }
        },
        methods:{

        }
    }
</script>

<style scoped>

</style>